export function getCyoSettingFilters(moduleType, moduleSubType ) {

    const fAttributes = [
        {
            name:'metal',
            label:'Metal',
            urlLabel:'Metal',
            type:'select', 
            hasIcon:true,
            iconBasePath:'/assets/metals/',
            iconType:'.png',
            singleSelect:true,
            default:null,
            isOpen:false
        },
        {
            name:'style',
            label:'Style',
            urlLabel:'Style',
            type:'select', 
            hasIcon:false,
            iconBasePath:'/assets/metals/',
            iconType:'.png',
            singleSelect:false,
            default:null,
            isOpen:false
        },
        {
            name:'shape',
            label:'shape',
            urlLabel:'Shape',
            type:'select', 
            displaySelected:false, 
            singleSelect:true,
            default:null,
            isOpen:false,
            config:{}
        },
        {
            name:'sort',
            label:'Sort',
            urlLabel:'Sort',
            type:'select', 
            displaySelected:true, 
            hasIcon:false,
            iconBasePath:'',
            iconType:'.svg',
            singleSelect:true,
            isOpen:false,
            default:'featured'
        },
        {
            name:'price',
            label:'Price',
            urlLabel:'Price',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            isOpen:false,
            config:{step:1, type: 'num', format:{notation:'$', position:'prepend'}}
        },
         {
            name:'estdate',
            label:'Estdate',
            urlLabel:'Estdate',
            type:'select', 
            displaySelected:true, 
            hasIcon:false,
            iconBasePath:'',
            iconType:'.svg',
            singleSelect:true,
            isOpen:false,
            default:'anydate'
        },
    ]

    if(['pendant', 'earring'].includes(moduleSubType)) {
        fAttributes.splice(1,1)
    }

    return fAttributes;
}